module.exports={"wireguard adapter settings":"Adapter settings for wireguard",option1:"option1",option2:"option2"};